module.exports = __webpack_public_path__ + "img/449.423c6089.jpg";